// extracted by mini-css-extract-plugin
export default {"inputsContainer":"inputsContainer--hauJDo4I","hyphen":"hyphen--xfTQ2z9h","inputTitle":"inputTitle--rqfaZ_QM","inputHint":"inputHint--lUqgvHBY"};